import { useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { paymentsAPI } from '../../api/payments';

// Auto-verifies a phone number against MakyPay once it looks complete and
// shows the registered account holder's name — the user confirms they typed
// the right number before any money moves. No button needed.
const PhoneAccountHint = ({ phone }) => {
  const [state, setState] = useState({ status: 'idle' });

  useEffect(() => {
    if (!phone || !isValidPhoneNumber(phone)) {
      setState({ status: 'idle' });
      return undefined;
    }
    setState({ status: 'checking' });
    const timer = setTimeout(async () => {
      try {
        const result = await paymentsAPI.verifyPhone(phone);
        if (result?.valid) {
          setState({ status: 'valid', name: result.name, provider: result.provider });
        } else {
          setState({ status: 'invalid', message: result?.message });
        }
      } catch (_) {
        setState({ status: 'idle' }); // network hiccup — stay quiet
      }
    }, 700);
    return () => clearTimeout(timer);
  }, [phone]);

  if (state.status === 'idle') return null;

  if (state.status === 'checking') {
    return (
      <p style={{ fontSize: '12px', color: 'var(--gray-9)', margin: '6px 0 0', textAlign: 'left' }}>
        Checking number…
      </p>
    );
  }

  if (state.status === 'invalid') {
    return (
      <p style={{ fontSize: '12px', color: 'var(--red-9, #e5484d)', margin: '6px 0 0', textAlign: 'left' }}>
        {state.message || 'This number is not registered for mobile money.'}
      </p>
    );
  }

  return (
    <p style={{ fontSize: '12px', color: '#16a34a', margin: '6px 0 0', textAlign: 'left', fontWeight: 600 }}>
      ✓ {state.name || 'Verified'}{state.provider ? ` · ${state.provider}` : ''}
    </p>
  );
};

export default PhoneAccountHint;
